import { Col, Form, Row, Skeleton, Space, Typography } from 'antd';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import styled from 'styled-components';
import useFetchQuery from '../../../../hooks/useFetchQuery';
import useTranslations from '../../../../hooks/useTranslations';
import { useBookingCtx } from '../context/BookingContext';

const { Text } = Typography;

const SpaceStyled = styled(Space)`
    gap: 1px !important;
    .ant-space-item {
        display: flex;
        justify-content: end;
    }
`;

/**
 * @param {object} props
 * @param {string[]} props.userLatLong
 * @param {string} props.refetchKey
 */
function BookingPreview({ userLatLong, refetchKey }) {
    const { t } = useTranslations();
    const { masseusesId } = useParams();

    const { formInstance } = useBookingCtx();

    const serivceId = Form.useWatch('service_id', formInstance);
    const voucherId = Form.useWatch('voucher', formInstance);
    const masseuseIdForm = Form.useWatch('masseuse_id', formInstance);

    const textTotalAmount = t('TotalAmount', 'Total Amount');
    const textIncludeTax = t('IncludeTax', 'Include Tax');
    const textTransport = t('Transport', 'Transport');
    const textOff = t('Off', 'Off');

    const { data, isLoading, refetch } = useFetchQuery({
        enabled: () => serivceId,
        method: 'post',
        url: '/bookings/preview',
        payload: {
            masseuse_id: Number(masseusesId) || masseuseIdForm,
            service_id: serivceId,
            user_lat: userLatLong?.[0],
            user_lng: userLatLong?.[1],
            voucher_id: voucherId,
        },
        onFetchSuccess: (data) => {
            formInstance.setFieldsValue({
                total_price: data?.data?.total_price,
            });
            return data?.data;
        },
    });

    useEffect(() => {
        if (!refetchKey) refetch();
    }, [refetchKey]);

    return (
        <Row align="middle" style={{ width: '100%' }}>
            {isLoading ? (
                <Skeleton active={isLoading} />
            ) : (
                <>
                    <Col flex="auto">{textTotalAmount}</Col>
                    <Col flex="none">
                        <SpaceStyled direction="vertical">
                            {data?.discount_amount ? (
                                <Space>
                                    <Text
                                        style={{
                                            color: 'var(--ant-error-color)',
                                        }}
                                    >
                                        <Text
                                            style={{
                                                textDecoration: 'line-through',
                                                color: 'var(--ant-error-color)',
                                            }}
                                        >
                                            ฿{data?.discount_amount}
                                        </Text>{' '}
                                        {textOff}
                                    </Text>
                                    <Text>{data?.price_before_discount}</Text>
                                </Space>
                            ) : null}
                            <Text strong>฿ {data?.total_price || 0}</Text>
                            <Text type="secondary">{`*${textIncludeTax} & ${textTransport}`}</Text>
                        </SpaceStyled>
                    </Col>
                </>
            )}
        </Row>
    );
}

export default BookingPreview;
